import { type FC, memo } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import { FIELD_WIDTHS } from 'modules/map/components/daily-dish/constants';
import StyledLabel from 'modules/map/components/daily-dish/components/utils/StyledLabel';

interface ColorPickerFieldProps {
  label: string;
  color: string;
  onColorChange: (color: string) => void;
  width?: string;
}
/**
 * Reusable color picker field component
 */
export const ColorPickerField: FC<ColorPickerFieldProps> = memo(
  ({ label, color, onColorChange, width = FIELD_WIDTHS.HALF }) => {
    return (
      <Box sx={{ width }}>
        <StyledLabel label={label} />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '40px',
            width: 'fit-content',
          }}
        >
          <TextField
            size="small"
            type="color"
            value={color}
            onChange={(e) => {
              onColorChange(e.target.value);
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  border: 'none',
                },
                '&:hover fieldset': {
                  border: 'none',
                },
                '&.Mui-focused fieldset': {
                  border: 'none',
                },
              },
            }}
            inputProps={{
              style: {
                padding: 0,
                margin: 0,
                height: '32px',
                aspectRatio: '1 / 1',
                cursor: 'pointer',
              },
            }}
          />
        </Box>
      </Box>
    );
  }
);
